import { c as _c } from "react/compiler-runtime";
// Tremor Raw Checkbox [v0.0.0]
import * as CheckboxPrimitives from "@radix-ui/react-checkbox";
import React from "react";
import { cx, focusRing } from "@/lib/tailwind-utils";
export type CheckboxColor = "default" | "green" | "red" | "yellow" | "blue" | "pink" | "gray" | "purple" | "indigo";
interface CheckboxProps extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitives.Root> {
  color?: CheckboxColor;
}
const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitives.Root>, CheckboxProps>((t0, forwardedRef) => {
  const $ = _c(24);
  let checked;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      checked,
      color: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    checked = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const color = t1 === undefined ? "default" : t1;
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[5] !== checked || $[6] !== className || $[7] !== color || $[8] !== forwardedRef || $[9] !== props) {
    const colorClasses = {
      default: "enabled:data-[state=checked]:bg-primary enabled:data-[state=indeterminate]:bg-primary",
      green: "enabled:data-[state=checked]:bg-green-400 enabled:data-[state=indeterminate]:bg-green-400",
      red: "enabled:data-[state=checked]:bg-red-400 enabled:data-[state=indeterminate]:bg-red-400",
      yellow: "enabled:data-[state=checked]:bg-yellow-400 enabled:data-[state=indeterminate]:bg-yellow-400",
      blue: "enabled:data-[state=checked]:bg-accent-400 enabled:data-[state=indeterminate]:bg-accent-400",
      pink: "enabled:data-[state=checked]:bg-pink-400 enabled:data-[state=indeterminate]:bg-pink-400",
      gray: "enabled:data-[state=checked]:bg-gray-400 enabled:data-[state=indeterminate]:bg-gray-400",
      purple: "enabled:data-[state=checked]:bg-purple-400 enabled:data-[state=indeterminate]:bg-purple-400",
      indigo: "enabled:data-[state=checked]:bg-indigo-400 enabled:data-[state=indeterminate]:bg-indigo-400"
    };
    T0 = CheckboxPrimitives.Root;
    t2 = forwardedRef;
    t3 = props;
    t4 = checked;
    t5 = cx("relative inline-flex size-4 shrink-0 appearance-none items-center justify-center rounded border shadow-sm outline-none transition duration-100 enabled:cursor-pointer", "text-white", "", "data-[disabled]:border-border data-[disabled]:bg-muted data-[disabled]:text-foreground-muted", "enabled:data-[state=checked]:border-0 enabled:data-[state=checked]:border-transparent", "enabled:data-[state=indeterminate]:border-0 enabled:data-[state=indeterminate]:border-transparent", colorClasses[color] || colorClasses.default, focusRing, className);
    $[5] = checked;
    $[6] = className;
    $[7] = color;
    $[8] = forwardedRef;
    $[9] = props;
    $[10] = T0;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    T0 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
  }
  let t6;
  if ($[15] !== checked) {
    t6 = <CheckboxPrimitives.Indicator className="flex size-full items-center justify-center">{checked === "indeterminate" ? <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><line stroke="currentColor" strokeLinecap="round" strokeWidth="2" x1="4" x2="12" y1="8" y2="8" /></svg> : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2 5.59998L6.79999 9.99998L4.79999 7.99998" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" /></svg>}</CheckboxPrimitives.Indicator>;
    $[15] = checked;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== T0 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <T0 ref={t2} {...t3} checked={t4} className={t5}>{t6}</T0>;
    $[17] = T0;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
});
Checkbox.displayName = "Checkbox";
export { Checkbox };